import { render, staticRenderFns } from "./Subheading.vue?vue&type=template&id=40aa4a4e&scoped=true&"
import script from "./Subheading.vue?vue&type=script&lang=js&"
export * from "./Subheading.vue?vue&type=script&lang=js&"
import style0 from "./Subheading.vue?vue&type=style&index=0&id=40aa4a4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aa4a4e",
  null
  
)

export default component.exports